import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';

const DirectGuaranteeSummary = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    axios.get(`/api/direct-orders/${orderId}`)
      .then(res => setOrder(res.data))
      .catch(err => console.error(err));
  }, [orderId]);

  if (!order) {
    return (
      <div className="max-w-4xl mx-auto pt-20 p-6">
        <div className="space-y-3">
          <div className="h-6 bg-gray-200 rounded w-1/3 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="max-w-4xl mx-auto pt-20 p-6 bg-white shadow-md rounded-md border">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A5 landscape; margin: 0; }
          body { margin: 0; }
        }
      `}</style>
  
      <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">Online Order Guarantee Summary</h1>
  
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-collapse rounded">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="border px-3 py-2">Image</th>
              <th className="border px-3 py-2">Product ID</th>
              <th className="border px-3 py-2">Product Name</th>
              <th className="border px-3 py-2 text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {order.items.map(item => (
              <tr key={item._id} className="hover:bg-gray-50">
                <td className="border p-2 text-center">
                  <img
                    src={`/uploads/${item.photo.replace(/\\/g, '/')}`}
                    className="w-12 h-12 object-cover rounded mx-auto"
                    alt={item.name}
                  />
                </td>
                <td className="border px-3 py-2">{item.productId}</td>
                <td className="border px-3 py-2">{item.name}</td>
                <td className="border px-3 py-2 text-center">
                  <Link
                    to={`/guarantee/direct/${orderId}/${item._id}`}
                    className="text-blue-600 hover:underline"
                  >
                    View Guarantee
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
  
      <div className="text-center mt-6">
        <button
          onClick={() => window.print()}
          className="no-print bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          Print Summary
        </button>
      </div>
    </div>
  );
  
};

export default DirectGuaranteeSummary;
